import * as React from 'react';

import {
  QRCodeContainer,
  QRCodeSubtitle,
  QRCodeTitle,
  QRCodeTitleContainer,
  QrDivider,
  StyledQRCode,
  StyledQRSkeleton,
} from 'pages/loyalty/loyalty-in-restaurant-redemption/loyalty-in-restaurant-redemption.styled';
import { useLoyaltyMyCode } from 'pages/loyalty/loyalty-in-restaurant-redemption/use-loyalty-my-code';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyUserId } from 'state/loyalty/hooks/use-loyalty-user';
import { primitive } from 'styles/constants/primitives';

const LoyaltyQrCodeLoyaltyIdWidget: React.FC = () => {
  const enableQrCodeLoyaltyIdFlag = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_QR_CODE_LOYALTY_ID);

  const { loyaltyUserId } = useLoyaltyUserId();
  const { data, loading } = useLoyaltyMyCode();

  const barcodeOptions = {
    margin: 1,
    scale: 6,
    color: {
      dark: primitive.$black,
      light: primitive.$white,
    },
  };

  if (!enableQrCodeLoyaltyIdFlag) {
    return null;
  }

  const qrCodeTitle = data?.myCodeQrHeading?.locale;
  const qrCodeSubTitle = data?.myCodeQrSubheading?.locale;

  return (
    <QRCodeContainer>
      <QrDivider></QrDivider>
      {!loading && (
        <QRCodeTitleContainer>
          <QRCodeTitle content={qrCodeTitle} />
        </QRCodeTitleContainer>
      )}
      {!loading && <QRCodeSubtitle content={qrCodeSubTitle} />}

      <StyledQRSkeleton isLoaded={!!loyaltyUserId}>
        <StyledQRCode
          testID="redemption-qr-code"
          barcode={loyaltyUserId || ''}
          options={barcodeOptions}
        />
      </StyledQRSkeleton>
    </QRCodeContainer>
  );
};

export default LoyaltyQrCodeLoyaltyIdWidget;
